export * from './baThemePreloader.service';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/services/baThemePreloader/index.ts